module.exports = __webpack_public_path__ + "img/banner_bg_002.f3602e1.webp";